import { createContext } from 'react';
import { IFormData } from '../models/formData';

const FormDataContext = createContext({} as IFormData);

export default FormDataContext;
